// // Truncate Text
// const truncate = (txt, num) => {
//   if (txt.length > num) {
//     return txt.slice(0, num) + "...";
//   } else {
//     return txt;
//   }
// }

// const cardHeadline = document.querySelectorAll(".card__content h6");
// const cardText = document.querySelectorAll(".card__content p");

// cardHeadline.forEach(item => {
//   const headline = truncate(item.innerHTML.trim(), 35);
//   item.innerHTML = headline;
// });

// cardText.forEach(item => {
//   const txt = truncate(item.innerHTML.trim(), 35);
//   item.innerHTML = txt;
// });